module.exports = __webpack_public_path__ + "images/accessoarer.a8ee612b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/accessoarer.jpg
// module id = 0231d918
// module chunks = 10 37